<template>
    <div>
        <!-- Modal Edição de Datas-->
        <div class="modal fade" :id="'edicaoDatasMarcacaoModal' + chave_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Datas
                            <span class="badge badge-secondary" v-if="datas">{{ datas.length }}</span>
                        </h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="datas">
                            <div class="mb-3">
                                <az-input
                                    type="button-group"
                                    sizing="sm"
                                    :optionsList="[
                                        { id: 'D', search: 'Data' }, 
                                        { id: 'DT', search: 'Data/Hora' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="tipo"
                                    @click="trocar_tipo()" />
                            </div>
                                
                            <div class="form-row" v-for="(data, idx) in datas" :key="idx">
                                <div class="col col-12" :class="cor_linha(data, idx)">
                                    <az-input 
                                        sizing="sm"
                                        v-model="datas[idx]" 
                                        :type="tipo == 'DT' ? 'datetime-local' : 'date'"
                                        required
                                        :validate="validate">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-outline-danger" @click="remover_item(idx)">
                                                    <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="data">
                                                <span class="input-group-text">
                                                    <span v-if="$util.getFormatDate(data, 'ddd') == 'Dom'" class="mr-2" title="Data informada para o Domingo.">
                                                        <i class="fa-solid fa-triangle-exclamation text-danger"></i>
                                                    </span>

                                                    <span v-else-if="!idx && data.slice(0,10) != marcacao.atendimento.dt_inicio.slice(0,10)" class="mr-2" title="Data diferente da data do atendimento.">
                                                        <i class="fa-solid fa-triangle-exclamation text-warning"></i>
                                                    </span>

                                                    {{ $util.getFormatDate(data, 'ddd') }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_data()">
                            <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../util/AzSubmit.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            datas: [], 
            marcacao: null, 
            guia: null, 
            validate: false, 
            tipo: 'D', 
        }
    },

    components: { 
        AzSubmit, 
        AzInput 
    },

    computed: { 
        chave_modal: function () { 
            return this.$util.uuidv4();
        }
    }, 

    methods: { 

        cor_linha (data, idx) { 
            if ( data ) { 
                
                let dia = this.$util.getFormatDate(data, 'ddd');

                if ( dia == 'Dom' ) { 
                    return 'alert-danger';
                } else if ( !idx && data && ( data.slice(0,10) != this.marcacao.atendimento.dt_inicio.slice(0,10) ) ) { 
                    return 'alert-warning';
                }
                
            }

            return '';
        },
        trocar_tipo () { 
            this.$nextTick(() => { 
                this.datas = this.datas.map(item => {
                    if ( item ) { 
                        if ( this.tipo == 'D' ) { 
                            return item.substr(0, 10);
                        } else { 
                            return item.length == 10 ? item + ' 00:00:00' : item.substr(0, 19);
                        }
                    }
                });

                console.log(this.tipo, this.datas);
            });
        },

        incluir_data () { 
            this.datas.push("");    
        },

        remover_item (idx) { 
            this.datas.splice(idx, 1);
        },

        fechar_modal() { 
            $('#edicaoDatasMarcacaoModal' + this.chave_modal).modal('hide');
        },

        abrir(marcacao, guia = null) { 
            this.tipo = 'D';

            let lista_datas;

            if ( guia && guia.js_datas && guia.js_datas.datas ) { 
                lista_datas = _.cloneDeep(_.get(guia, 'js_datas.datas', []));     
            } else { 
                lista_datas = _.cloneDeep(_.get(marcacao, 'atendimento.js_info.datas', [])); 
            }

            let teste = _.get(lista_datas, '0', '');

            if ( typeof teste == 'string' ) { 
                if ( teste.length > 10 ) { 
                    this.tipo = 'DT';
                }
            }

            this.validate = false; 
            this.marcacao = marcacao; 
            this.guia = guia;
            this.datas = lista_datas;
            
            if ( !this.datas ) { 
                this.datas = [];
            }

            $('#edicaoDatasMarcacaoModal' + this.chave_modal).modal('show');
        },

        atualizar() { 
            this.validate = true;

            if ( this.datas.find(item => !item) ) { 
                return;
            }

            this.$emit('lancar', this.datas);
            this.fechar_modal();
        },

    }

}
</script>
